<template>
  <div class="custom-time-picker" :class="{'disabled': disabled, 'dark': dark, 'error-outline': !valid}">
    <vue-timepicker
      v-model="time"
      auto-scroll
      :placeholder="placeholder"
      :minute-interval="minuteInterval"
      hide-dropdown
      :format="formatType"
      :fixed-dropdown-button="!disabled"
      close-on-complete
      hour-label="hr"
      minute-label="min"
      apm-label="am/pm"
      hide-clear-button
      :disabled="disabled">
      <template v-slot:dropdownButton v-if="!disabled">
        <v-icon>mdi-clock-outline</v-icon>
      </template>
    </vue-timepicker>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat.js';
dayjs.extend(customParseFormat)
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue';

export default {
  name: 'EsTimePicker',
  components: {
    VueTimepicker,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    initialTime: String,
    formatType: {
      type: String,
      default: 'hh:mm A',
    },
    returnedFormat: {
      type: String,
      default: 'hh:mm A',
    },
    minuteInterval: {
      type: Number,
      default: 30,
    },
    placeholder: {
      type: String,
      default: '',
    },
    dark: {
      type: Boolean,
      default: false,
    },
    valid: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    time: {
      get() {
        const formatted = dayjs(this.initialTime, this.formatType).format(this.formatType);
        return formatted;
      },
      set(value) {
        const formatted = dayjs(value, this.formatType).format(this.returnedFormat);
        this.$emit('setTime', formatted);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-time-picker::v-deep .vue__time-picker {
  width: 100%;
  min-width: 115px;
  input.display-time {
    width: 100%;
    height: 3.5em;
    padding: 0.3em 10px;
    border-radius: 4px;
    color: rgba(0, 0, 0, 0.87);
    border: 1px solid rgba(0, 0, 0, 0.38);
    transition-duration: .3s;
    transition-property: border;
    transition-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1);
    &:focus-visible {
      outline: none;
      border: 2px solid var(--v-primary-base);
    }
  }
  .dropdown ul li.active {
    background: var(--v-primary-base) !important;
  }
  .controls {
    right: 10px;
  }
}
.custom-time-picker.disabled::v-deep .vue__time-picker {
  input.display-time {
    color: rgba(0, 0, 0, 0.38);
  }
}

.custom-time-picker.dark::v-deep .vue__time-picker {
  input.display-time {
    color: whitesmoke;
    border: 1px solid #616161;
  }
  .dropdown ul li,
  .vue__time-picker-dropdown ul li {
    color: whitesmoke;
  }
  .dropdown {
    background: #313131;
  }
  .dropdown ul.minutes,
  .vue__time-picker .dropdown ul.seconds,
  .vue__time-picker .dropdown ul.apms,
  .vue__time-picker-dropdown ul.minutes,
  .vue__time-picker-dropdown ul.seconds,
  .vue__time-picker-dropdown ul.apms {
    border-left: 1px solid #616161;
  }
}

.vue__time-picker-dropdown {
  z-index: 5000;
  font-family: sans-serif;
}

.custom-time-picker.error-outline::v-deep .vue__time-picker {
  input.display-time {
    border: 2px solid var(--v-error-base);
  }
}
</style>
